import React from 'react';
import { Typography } from '@mui/material';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/sharp-regular-svg-icons';

export const FaCalendar: React.FunctionComponent = function () {
    return (
        <Typography color="secondary">
            <FontAwesomeIcon
                size="xl"
                icon={faCalendar}
            />
        </Typography>
    );
};
